import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import withStyles from "@material-ui/styles/withStyles";
import { Grid, Drawer } from "@material-ui/core";

import { styles } from "./Alerts.styles";
import AlertContainer from "./components/AlertContainer";
import {
  selectAlerts,
  getAlerts,
  selectSelectedProject,
  activateAlert,
  selectLoader,
  removeAlert,
} from "./alertsSlice";
import { usePrevious } from "../../common/hooks/usePrevious";
import AlertForm from "./components/AlertForm";
import { selectStructure, getStructure } from "../structure/structureSlice";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";

function Alerts({ classes }) {
  const selectedProject = useSelector(selectSelectedProject);
  const alerts = useSelector(selectAlerts);
  const loading = useSelector(selectLoader);
  const dispatch = useDispatch();
  const prevSelectedProject = usePrevious(selectedProject);
  const [selectedAlert, setSelectedAlert] = useState();
  const [drawerAlertOpen, setDrawerAlertOpen] = useState(false);
  const structure = useSelector(selectStructure);
  const [confirmRemoveAlertDialogOpen, setConfirmRemoveAlertDialogOpen] =
    useState(false);

  useEffect(() => {
    if (!alerts) {
      dispatch(getAlerts(selectedProject));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      !alerts ||
      alerts.length === 0 ||
      prevSelectedProject?.id !== selectedProject?.id
    ) {
      dispatch(getAlerts(selectedProject));
    }
    if (
      !structure ||
      structure.length === 0 ||
      prevSelectedProject?.id !== selectedProject?.id
    ) {
      dispatch(getStructure(selectedProject));
    }
    // eslint-disable-next-line
  }, [selectedProject]);

  const alertSubmitHandler = () => {
    console.log("f sub");
    setDrawerAlertOpen(false);
    dispatch(getAlerts(selectedProject));
  };

  const onActivateHandler = (id, value) => {
    console.log("switch: %o", { id, value });
    dispatch(activateAlert(selectedProject, id, value));
    dispatch(getAlerts(selectedProject));
  };

  const onEditAlertHandler = (alert) => {
    setSelectedAlert(alert);
    setDrawerAlertOpen(true);
  };

  const onDeleteAlertHandler = (alert) => {
    setSelectedAlert(alert);
    setConfirmRemoveAlertDialogOpen(true);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        {alerts &&
          alerts.map((zone, i) => {
            return (
              <Grid item sm={6} xs={12} key={"alertZone_" + i}>
                <AlertContainer
                  onEditAlert={onEditAlertHandler}
                  onDeleteAlert={onDeleteAlertHandler}
                  setSelectedAlert={setSelectedAlert}
                  setDrawerAlertOpen={setDrawerAlertOpen}
                  classes={classes}
                  zoneId={zone.zoneId}
                  zone={zone.zone}
                  alerts={zone.alerts}
                  onActivate={onActivateHandler}
                  loading={loading}
                />
              </Grid>
            );
          })}
      </Grid>
      <Drawer
        anchor="right"
        open={drawerAlertOpen}
        onClose={() => setDrawerAlertOpen(false)}
      >
        <div className={classes.drawer}>
          <AlertForm
            payload={selectedAlert}
            structure={structure}
            selectedProject={selectedProject}
            onSubmit={alertSubmitHandler}
          />
        </div>
      </Drawer>
      <ConfirmationDialog
        labels={{
          title: "Delete Alert",
          description:
            "Are you sure you want to delete this alert: " +
            selectedAlert?.designation,
          ok: "OK",
          cancel: "CANCEL",
        }}
        open={confirmRemoveAlertDialogOpen}
        onCancel={() => {
          setConfirmRemoveAlertDialogOpen(false);
        }}
        onConfirm={() => {
          setConfirmRemoveAlertDialogOpen(false);
          dispatch(removeAlert(selectedProject, selectedAlert.id));
          dispatch(getAlerts(selectedProject));
          setSelectedAlert();
        }}
      />
    </div>
  );
}

export default withStyles(styles)(Alerts);
